export default __webpack_public_path__ + "img/Poppins-ExtraLight_41cf962.woff";